export default {
  HOVER: 'hover',
  SELECT: 'select',
};
